// Browser-held composer drafts use the same 8,000-code-point ceiling as Agent trigger messages. Keeping the
// browser bound in one client module prevents the global and Task draft registries drifting without making
// the browser bundle import Agent runtime code.

export const MAX_RETAINED_DRAFT_CODE_POINTS = 8_000;

/** Bound a retained draft without splitting a surrogate pair. Deliberate whitespace remains user text. */
export function boundRetainedDraft(value: string): string {
  return Array.from(value).slice(0, MAX_RETAINED_DRAFT_CODE_POINTS).join('');
}
